// shared components
import Modal from '@/shared/Modal.vue';
import BaseIcon from '@/shared/base-icon.vue';
import BaseIconSvg from '@/shared/base-icon-svg.vue';
import InputArea from '@/shared/InputArea.vue';
import Snackbar from '@/shared/MaterialComponents/Snackbar.vue';
import Banner from '@/shared/Banner.vue';

export default {
	install(Vue) {
		// register components globally | no need to import in specific pages
		Vue.component('modal', Modal);
		if (IS_WEB_COMPONENT) {
			Vue.component('base-icon', BaseIconSvg);
		} else {
			Vue.component('base-icon', BaseIcon);
		}
		Vue.component('input-area', InputArea);
		Vue.component('snack-bar', Snackbar);
		Vue.component('banner', Banner);
	},
};
